import { definePreset, palette } from '@primevue/themes'
import Aura from '@primevue/themes/aura'

/**
 * Aura с холодным акцентом (sky) и нейтральными zinc-поверхностями.
 * Зелёный/жёлтый/красный оставлены свободными под статусы ботов,
 * поэтому primary специально не зелёный.
 */
const mistPalette = palette('#495169')

export const RealsSaverPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '{teal.50}',
      100: '{teal.100}',
      200: '{teal.200}',
      300: '{teal.300}',
      400: '{teal.400}',
      500: '{teal.500}',
      600: '{teal.600}',
      700: '{teal.700}',
      800: '{teal.800}',
      900: '{teal.900}',
      950: '{teal.950}',
    },
    colorScheme: {
      dark: {
        surface: {
          0: '#ffffff', // Абсолютно белый (обычно нужен для 0)
          50: mistPalette[50],
          100: mistPalette[100],
          200: mistPalette[200],
          300: mistPalette[300],
          400: mistPalette[400],
          500: mistPalette[500],
          600: mistPalette[600],
          700: mistPalette[700],
          800: mistPalette[800],
          900: mistPalette[900],
          950: mistPalette[950],
        },
      },
    },
  },
})
